<script setup lang="ts">
import type { ReportTemplate } from "@/types/report-templates.types";
import TemplateIcon from "../UI/icons/TemplateIcon.vue";
import TemplateActionsDropdown from "./TemplateActionsDropdown.vue";
import { useDates } from "@/composable/useDates";
import type { ItemDisplayMode } from "@/stores/Settings";
import DRDisplayItem from "../UI/items/DRDisplayItem.vue";

const { formatDistanceToNow } = useDates();
defineProps<{
  template: ReportTemplate;
  tileStyle?: string;
  display: ItemDisplayMode;
}>();

defineEmits<{
  (e: "select"): void;
}>();
</script>

<template>
  <DRDisplayItem
    @click="$emit('select')"
    :style="tileStyle"
    :title="template.name"
    :subtitle="
      template.createdAt
        ? $t('Added') + ` ${formatDistanceToNow(template.createdAt)}`
        : ''
    "
    :display="display"
  >
    <template #icon="{ size }"><TemplateIcon :size="size" /></template>

    <template #actions>
      <TemplateActionsDropdown :template="template" :size="30" />
    </template>

    <template #append1><slot name="footer"></slot></template>
  </DRDisplayItem>
</template>
